import { render, staticRenderFns, recyclableRender, components } from "./uni-swipe-action.vue?vue&type=template&id=919f0c78&"
var renderjs
import script from "./uni-swipe-action.vue?vue&type=script&lang=js&"
export * from "./uni-swipe-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_@dcloudio_vue-cli-plugin-uni@2.0.0-28320200727001@@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/uni-swipe-action/uni-swipe-action.vue"
export default component.exports